import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Icon } from '@breezeway/brzw-components';

import './flyout_section.scss';

const CLASS_NAME = 'brzw-flyout-section';

const FlyoutSection = ({ id, children, className, icon, title, titleElement, withSeparator }) => (
  <div
    className={classnames(CLASS_NAME, className, {
      [`${CLASS_NAME}--with-separator`]: withSeparator,
    })}
    id={id}
  >
    <div className={`${CLASS_NAME}__header`}>
      {icon && <Icon className={`${CLASS_NAME}__title-icon`} iconName={icon} />}
      {title && <div className={`${CLASS_NAME}__title`}>{title}</div>}
      {titleElement && titleElement}
    </div>
    {children && <div className={`${CLASS_NAME}__content`}>{children}</div>}
  </div>
);

FlyoutSection.propTypes = {
  children: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.node]),
  className: PropTypes.string,
  icon: PropTypes.string,
  id: PropTypes.string,
  title: PropTypes.string.isRequired,
  titleElement: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.node]),
  withSeparator: PropTypes.bool,
};

FlyoutSection.defaultProps = {
  className: '',
  withSeparator: false,
};

export default FlyoutSection;
